import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Outer replica skeleton for the project detail shell layout.
 * Mirrors the full page structure: header, tabs, and content area.
 * Rendered as a safeguard while project data is loading.
 */
export default function ProjectShellSkeleton() {
  return (
    <div className="min-h-screen bg-primary-50 dark:bg-primary-950 py-24">
      <div className="container-elegant max-w-4xl">
        {/* Header */}
        <div className="flex flex-col gap-4 mb-8 md:flex-row md:justify-between md:items-start">
          <div className="min-w-0 space-y-4">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-6 w-48" />
          </div>
          <div className="flex flex-wrap gap-4 shrink-0">
            <Skeleton className="h-10 w-36" />
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-10 w-10" />
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mb-8">
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-20" />
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-28" />
        </div>

        {/* Content — two-column grid matching InfoTab layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-6">
            <Card>
              <CardContent className="p-8 space-y-4">
                <Skeleton className="h-6 w-48" />
                {Array.from({ length: 6 }).map((_, index) => (
                  <div key={index}>
                    <Skeleton className="h-4 w-32 mb-1" />
                    <Skeleton className="h-4 w-24" />
                  </div>
                ))}
              </CardContent>
            </Card>
          </div>

          <div className="space-y-6">
            <Card>
              <CardContent className="p-8 space-y-3">
                <Skeleton className="h-6 w-40 mb-4" />
                {Array.from({ length: 3 }).map((_, index) => (
                  <div key={index} className="flex items-center justify-between py-2 border-b border-primary-100 dark:border-primary-800 last:border-b-0">
                    <div className="space-y-1">
                      <Skeleton className="h-5 w-32" />
                      <Skeleton className="h-4 w-48" />
                      <Skeleton className="h-3 w-16" />
                    </div>
                  </div>
                ))}
              </CardContent>
            </Card>

            <Card>
              <CardContent className="p-8 space-y-1">
                <Skeleton className="h-6 w-40 mb-4" />
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-48" />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
